export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14871.e2c84ac1.jpg";